import { render, staticRenderFns } from "./BarEl.vue?vue&type=template&id=f4425a24&scoped=true&"
import script from "./BarEl.vue?vue&type=script&lang=ts&"
export * from "./BarEl.vue?vue&type=script&lang=ts&"
import style0 from "./BarEl.vue?vue&type=style&index=0&id=f4425a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4425a24",
  null
  
)

export default component.exports